import React from 'react';
import { isEditor } from '../../utils/isEditor.js';
import VALoanCalculator from './VALoanCalculator.js';
import { FieldConfig } from './VALoanCalculator.utils.js';

var _attributes;
var VALoanCalculatorBlock = {
  Component: function Component(_ref) {
    var attrs = _ref.attrs;
    var homeprice = attrs.homeprice,
      loanProgram = attrs.loanProgram,
      interestRate = attrs.interestRate,
      downPayment = attrs.downPayment,
      downPaymentPercent = attrs.downPaymentPercent,
      homeInsurance = attrs.homeInsurance,
      hoa = attrs.hoa,
      taxRatePercent = attrs.taxRatePercent,
      taxRate = attrs.taxRate,
      includeTaxesInsurance = attrs.includeTaxesInsurance;
    var defaultValues = {
      homeprice: homeprice,
      loanProgram: loanProgram,
      interestRate: interestRate,
      downPayment: downPayment,
      downPaymentPercent: downPaymentPercent,
      homeInsurance: homeInsurance,
      hoa: hoa,
      taxRatePercent: taxRatePercent,
      taxRate: taxRate,
      includeTaxesInsurance: includeTaxesInsurance
    };
    return /*#__PURE__*/React.createElement(VALoanCalculator, {
      key: isEditor() ? JSON.stringify(defaultValues) : undefined,
      defaultValues: defaultValues
    });
  },
  metadata: {
    version: '1.0',
    name: 'constellation/va-calculator',
    title: 'VA calculator',
    description: 'VA home loan calculator to estimate monthly mortgage payment with taxes and insurance.',
    icon: 'businessperson',
    keywords: ['mortgages', 'calculators', 'va', 'veterans', 'military'],
    category: 'Calculators',
    supports: {
      customClassName: false,
      html: false
    },
    attributes: (_attributes = {}, _attributes[FieldConfig.homePrice.name] = {
      type: 'number',
      label: 'Default home price',
      default: 300000,
      control: 'number'
    }, _attributes[FieldConfig.loanProgram.name] = {
      type: 'number',
      label: 'Default loan program',
      default: 360,
      control: 'select',
      choices: FieldConfig.loanProgram.options
    }, _attributes[FieldConfig.interestRate.name] = {
      type: 'number',
      label: 'Default interest rate',
      default: 4.176,
      control: 'number'
    }, _attributes[FieldConfig.downPayment.name] = {
      type: 'number',
      label: 'Default down payment',
      default: 60000,
      control: 'number'
    }, _attributes[FieldConfig.downPaymentPercent.name] = {
      type: 'number',
      label: 'Default down payment percent',
      default: 20,
      control: 'number'
    }, _attributes[FieldConfig.homeInsurance.name] = {
      type: 'number',
      label: 'Default home insurance',
      default: 1260,
      control: 'number'
    }, _attributes[FieldConfig.hoa.name] = {
      type: 'number',
      label: 'Default hoa dues',
      default: 0,
      control: 'number'
    }, _attributes[FieldConfig.taxRate.name] = {
      type: 'number',
      label: 'Default property tax',
      default: 3600,
      control: 'number'
    }, _attributes[FieldConfig.taxRatePercent.name] = {
      type: 'number',
      label: 'Default property tax percent',
      default: 1.2,
      control: 'number'
    }, _attributes[FieldConfig.includeTaxesInsurance.name] = {
      type: 'boolean',
      default: 'true',
      label: 'Default include taxes/insurance',
      control: 'boolean'
    }, _attributes)
  }
};
var VALoanCalculatorBlock$1 = VALoanCalculatorBlock;

export { VALoanCalculatorBlock$1 as default };
